import styled from 'styled-components'

export const SoundsListSkeletonContainer = styled.div`
  position: relative;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  & > div {
    padding: 0;
  }
`

export const SoundsListItemWrapper = styled.div`
  min-height: 48px;
`
